import { render, staticRenderFns } from "./ApprovalPage.vue?vue&type=template&id=ddacb71a"
import script from "./ApprovalPage.vue?vue&type=script&lang=ts"
export * from "./ApprovalPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddacb71a')) {
      api.createRecord('ddacb71a', component.options)
    } else {
      api.reload('ddacb71a', component.options)
    }
    module.hot.accept("./ApprovalPage.vue?vue&type=template&id=ddacb71a", function () {
      api.rerender('ddacb71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/approval/ApprovalPage.vue"
export default component.exports